import React, { memo } from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import isEqual from "react-fast-compare";
import { useLocation } from "react-use";

type PropTypes = {
  open: boolean;
  onClose(): void;
};

const VoucherListTips = memo(() => {
  return (
    <>
      <Typography>Some dialog content for tips and tricks</Typography>
    </>
  );
});

const EditPageTips = memo(() => {
  return (
    <>
      <Typography>
        Some dialog content for tips and tricks on voucher edit page
      </Typography>
    </>
  );
});

const TipsAndTricksDialog = ({ open, onClose }: PropTypes) => {
  const { pathname } = useLocation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Tips and Tricks</DialogTitle>
      <DialogContent>
        {pathname?.includes("/edit") ? <EditPageTips /> : <VoucherListTips />}
      </DialogContent>
    </Dialog>
  );
};

export default memo(TipsAndTricksDialog, isEqual);
